module.exports = __webpack_public_path__ + "img/79140935.eab57f92.png";